// 통합 문서 작성은 두 곳에서 열린다.
//   /docstudio  — TIM_BOX 안의 메뉴(왼쪽 레일·상단바가 있는 화면)
//   /teamdocs   — '팀_문서' 앱 전용(문서 관리만, 다른 메뉴 없음)
// 화면 안의 이동은 지금 들어와 있는 쪽 경로를 그대로 따라간다.
export function docsBase(): "/teamdocs" | "/docstudio" {
  return window.location.pathname.startsWith("/teamdocs") ? "/teamdocs" : "/docstudio";
}
// mode: "view" = 미리보기(보기 전용, 빠름) · "edit" = 편집(기본)
export const viewPath = (id: string, mode: "view" | "edit" = "edit") =>
  `${docsBase()}/view/${id}${mode === "view" ? "?mode=view" : ""}`;
